<template>
    <div class="d-flex justify-content-center align-items-center vh-100">
        <div>Error page</div>
    </div>
</template>

<script>
import {useStatesStorage} from "../../stores/store";
import {storeToRefs} from "pinia";

export default {
    setup() {
        const statesStorage = useStatesStorage();
        const { viewStates } = storeToRefs(statesStorage);

        viewStates.value.show_preloader_spinner = false;
        return {
            viewStates

        }
    }
}
</script>

<style scoped>

</style>